import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import md5 from "md5";
import { poppins } from "./font";
export const Url = {
  get get() {
    var vars = {};
    if (window.location.search.length !== 0)
      window.location.search.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
          key = decodeURIComponent(key);
          if (typeof vars[key] === "undefined") {
            vars[key] = decodeURIComponent(value);
          } else {
            vars[key] = [].concat(vars[key], decodeURIComponent(value));
          }
        }
      );
    return vars;
  },
};

export const encodedUrlBuliding = (nameUrl, columnData) => {
  if (columnData === null || columnData == "undefined") {
    return "#";
  }

  if (nameUrl == "owner") {
    var url = `{"owner":[{"id":"o-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/owner/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "complex") {
    var url = `{"complex":[{"id":"b-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/asset/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "tenant") {
    var url = `{"tenant":[{"id":"t-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/occupier/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "micromarket") {
    var url = `{"micromarket":[{"id":"sm-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/region/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "developer") {
    var url = `{"developer":[{"id":"d-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/developer/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "city") {
    var url = `{"city":[{"id":"c-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/region/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "macromarket") {
    var url = `{"macromarket":[{"id":"mam-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/region/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "leaseId") {
    var url = `{"Lease_Id":[{"id":"cre-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/custom/?filter=" + encodeURIComponent(url);
    return url;
  } else if (nameUrl == "building_grade") {
    var url = `{"building_grade":[{"id":"bg-${md5(
      columnData
    )}","value":"${columnData}","label":"${columnData}"}]}`;
    url = "/office/asset/?filter=" + encodeURIComponent(url);
    return url;
  } else {
    return "#";
  }
};

export const BodyAsFormData = (filter) => {
  var body = new FormData();

  body.append("filter", filter);
  return body;
};

export const filterDataFromUrl = (filterData) => {
  if (typeof filterData === "undefined") {
    return {};
  }
  // console.log(filterData)
  let filters = JSON.parse(filterData);
  //console.log(filters);
  let keyMapping = {
    city: "markets",
    region: "region",
    macromarket: "macromarkets",
    micromarket: "micromarkets",
    pincode: "pincodes",
    complex: "complexes",
    building: "buildings",
    building_grade: "building-grade",
    // 'propertytype': 'propertyTypes',
    building_category: "buildingCategory",
    spacetype: "spaceTypes",
    property_condition: "propertyCondition",
    tenant: "tenants",
    sector: "sector",
    developer: "developers",
    landlord: "landlords",
    ownership_type: "ownershipType",
    owner: "owners",
    renewed_lease: "renewed-lease",
    document_type: "documentType",
    active: "lease-status",
    Lease_Id: "creid",
    Sale_Id: "cresaleid",
    seller: "seller",
    purchaser: "purchaser",
    brand_sub_category: "brand_sub_category",
    brands_parent: "brandsParent",
    end_status: "endStatus",

    securityDeposit: "securityDeposit",
    startingRent: "startingRent",
    startingRentCarpet: "startingRentCarpet",
    currentRent: "currentRent",
    currentRentCarpet: "currentRentCarpet",
    leaseTerm: "leaseTerm",
    rentFreePeriod: "rentFreePeriod",
    lockinPeriod: "lockinPeriod",
    transactionSize: "transactionSize",
    perSqFt: "perSqFt",
    totalConsideration: "totalConsideration",
    areaPurchased: "areaPurchased",
    rsStartingRentPercent: "rsStartingRentPercent",
    rsCurrentRentPercent: "rsCurrentRentPercent",

    start_leaseExpiryDate: "leaseExpiryDateMin",
    end_leaseExpiryDate: "leaseExpiryDateMax",
    start_lockinPeriodEndDate: "lockinPeriodEndDateMin",
    end_lockinPeriodEndDate: "lockinPeriodEndDateMax",
    start_executionDate: "executionDateMin",
    end_executionDate: "executionDateMax",
    start_commencementDate: "commencementDateMin",
    end_commencementDate: "commencementDateMax",
    start_absorptionDate: "absorptionDateMin",
    end_absorptionDate: "absorptionDateMax",
    start_occupancy_date_orig: "occupancy_date_origMin",
    end_occupancy_date_orig: "occupancy_date_origMax",
    start_exitDate: "exitDateMin",
    end_exitDate: "exitDateMax",

    floor_number: "floor_number",

    complexChargeableArea: "complexChargeableArea",
    buildingChargeableArea: "buildingChargeableArea",
  };

  var submitValues = {};
  Object.keys(filters).map((field, i) => {
    if (
      filters[field] === null ||
      filters[field].length === 0 ||
      filters[field] === "" ||
      (Array.isArray(filters[field]) &&
        filters[field].join("|") === [0, 0].join("|"))
    ) {
    } else {
      if (
        field == "securityDeposit" ||
        field == "startingRent" ||
        field == "startingRentCarpet" ||
        field == "currentRent" ||
        field == "currentRentCarpet" ||
        field == "leaseTerm" ||
        field == "rentFreePeriod" ||
        field == "lockinPeriod" ||
        field == "transactionSize" ||
        field == "perSqFt" ||
        field == "totalConsideration" ||
        field == "areaPurchased" ||
        field == "rsStartingRentPercent" ||
        field == "rsCurrentRentPercent" ||
        field == "complexChargeableArea" ||
        field == "buildingChargeableArea"
      ) {
        submitValues[field + "Start"] = [
          {
            value: filters[field][0].toString(),
            id: "",
            label: filters[field][0].toString(),
          },
        ];
        submitValues[field + "End"] = [
          {
            value: filters[field][1].toString(),
            id: "",
            label: filters[field][1].toString(),
          },
        ];
      } else if (
        field == "start_leaseExpiryDate" ||
        field == "end_leaseExpiryDate" ||
        field == "start_lockinPeriodEndDate" ||
        field == "end_lockinPeriodEndDate" ||
        field == "start_executionDate" ||
        field == "end_executionDate" ||
        field == "start_commencementDate" ||
        field == "end_commencementDate" ||
        field == "start_absorptionDate" ||
        field == "end_absorptionDate" ||
        field == "start_occupancy_date_orig" ||
        field == "end_occupancy_date_orig" ||
        field == "start_exitDate" ||
        field == "end_exitDate"
      ) {
        submitValues[keyMapping[field]] = [
          {
            value: moment(filters[field]).format("X"), //moment(filters[field]).format("X") + "000",
            id: "",
            label: moment(filters[field]).format("YYYY-MM-DD"),
          },
        ];
      } else {
        if (typeof keyMapping[field] !== "undefined")
          submitValues[keyMapping[field]] = filters[field];
      }
    }
  });
  return submitValues;
};

export const urlFromFilterData = (json) => {
  let filters = JSON.parse(json);
  let keyMapping = {
    markets: "city",
    macromarkets: "macromarket",
    micromarkets: "micromarket",
    pincodes: "pincode",
    complexes: "complex",
    buildings: "building",
    "building-grade": "building_grade",
    // 'propertyTypes': 'propertytype',
    buildingCategory: "building_category",
    spaceTypes: "spacetype",
    propertyCondition: "property_condition",
    tenants: "tenant",
    sector: "sector",
    developers: "developer",
    landlords: "landlord",
    ownershipType: "ownership_type",
    owners: "owner",
    "renewed-lease": "renewed_lease",
    documentType: "document_type",
    "lease-status": "active",
    creid: "Lease_Id",
    cresaleid: "Sale_Id",
    seller: "seller",
    purchaser: "purchaser",
    brand_sub_category: "brand_sub_category",
    brandsParent: "brands_parent",
    endStatus: "end_status",

    securityDepositStart: "securityDeposit",
    startingRentStart: "startingRent",
    startingRentCarpetStart: "startingRentCarpet",
    currentRentStart: "currentRent",
    currentRentCarpetStart: "currentRentCarpet",
    leaseTermStart: "leaseTerm",
    rentFreePeriodStart: "rentFreePeriod",
    lockinPeriodStart: "lockinPeriod",
    transactionSizeStart: "transactionSize",
    perSqFtStart: "perSqFt",
    totalConsiderationStart: "totalConsideration",
    areaPurchasedStart: "areaPurchased",
    rsStartingRentPercentStart: "rsStartingRentPercent",
    rsCurrentRentPercentStart: "rsCurrentRentPercent",

    leaseExpiryDateMin: "start_leaseExpiryDate",
    leaseExpiryDateMax: "end_leaseExpiryDate",
    lockinPeriodEndDateMin: "start_lockinPeriodEndDate",
    lockinPeriodEndDateMax: "end_lockinPeriodEndDate",
    executionDateMin: "start_executionDate",
    executionDateMax: "end_executionDate",
    commencementDateMin: "start_commencementDate",
    commencementDateMax: "end_commencementDate",
    absorptionDateMin: "start_absorptionDate",
    absorptionDateMax: "end_absorptionDate",
    occupancy_date_origMin: "start_occupancy_date_orig",
    occupancy_date_origMax: "end_occupancy_date_orig",
    exitDateMin: "start_exitDate",
    exitDateMax: "end_exitDate",

    floor_number: "floor_number",

    complexChargeableArea: "complexChargeableArea",
    buildingChargeableArea: "buildingChargeableArea",
  };

  var submitValues = {};
  Object.keys(filters).map((field, i) => {
    if (
      filters[field] === null ||
      filters[field].length === 0 ||
      filters[field] === "" ||
      (Array.isArray(filters[field]) &&
        filters[field].join("|") === [0, 0].join("|"))
    ) {
    } else {
      if (
        field == "securityDepositStart" ||
        field == "startingRentStart" ||
        field == "startingRentCarpetStart" ||
        field == "currentRentStart" ||
        field == "currentRentCarpetStart" ||
        field == "leaseTermStart" ||
        field == "rentFreePeriodStart" ||
        field == "lockinPeriodStart" ||
        field == "transactionSizeStart" ||
        field == "perSqFtStart" ||
        field == "totalConsiderationStart" ||
        field == "areaPurchasedStart" ||
        field == "rsStartingRentPercentStart" ||
        field == "rsCurrentRentPercentStart" ||
        field == "complexChargeableArea" ||
        field == "buildingChargeableArea"
      ) {
        let key = field.replace(/Start$/g, "");
        submitValues[key] = [
          parseInt(filters[key + "Start"][0]["label"]),
          parseInt(filters[key + "End"][0]["label"]),
        ];
      } else if (
        field == "leaseExpiryDateMin" ||
        field == "lockinPeriodEndDateMin" ||
        field == "executionDateMin" ||
        field == "commencementDateMin" ||
        field == "absorptionDateMin" ||
        field == "occupancy_date_origMin" ||
        field == "exitDateMin"
      ) {
        let key = field.replace(/Min$/g, "");
        submitValues["start_" + key] = moment(
          moment(filters[key + "Min"][0]["label"], "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          )
        )
          .utcOffset(330)
          .format();
      } else if (
        field == "leaseExpiryDateMax" ||
        field == "lockinPeriodEndDateMax" ||
        field == "executionDateMax" ||
        field == "commencementDateMax" ||
        field == "absorptionDateMax" ||
        field == "occupancy_date_origMax" ||
        field == "exitDateMax"
      ) {
        let key = field.replace(/Max$/g, "");
        submitValues["end_" + key] = moment(
          moment(filters[key + "Max"][0]["label"], "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          )
        )
          .utcOffset(330)
          .format();
      } else {
        if (typeof keyMapping[field] !== "undefined")
          submitValues[keyMapping[field]] = filters[field];
      }
    }
  });
  return JSON.stringify(submitValues);
};

export const DynamicColors = () => {
  var r = Math.floor(Math.random() * 255);
  var g = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  return "rgb(" + r + "," + g + "," + b + ")";
};

export const downloadPdf = (id, pdfName) => {
  const doc = new jsPDF({
    orientation: "landscape",
  });
  doc.addFileToVFS("poppins.ttf", poppins);

  doc.addFont("poppins.ttf", "poppins", "regular", "Identity-H");
  doc.setFont("poppins"); // set font
  doc.autoTable({
    html: id,
    theme: "striped",
    margin: { top: 10 },
    headerStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "poppins",
    },
    columnStyles: {
      font: "poppins",
    },
  });
  doc.save(`${pdfName}.pdf`);
};

export const noDataForGraph = (dataset) => {
  var dataStatus = false;
  if (dataset == null || typeof dataset === "undefined") {
    return false;
  }

  if (Array.isArray(dataset)) {
    if (dataset.length <= 0) {
      return false;
    }
  }
  for (let i = 0; i < dataset.length; i++) {
    if (
      dataset[i] != null &&
      dataset[i] != "" &&
      dataset[i] != 0 &&
      dataset[i] != "0"
    ) {
      dataStatus = true;
    }
  }
  // console.log('dataStatus:');
  // console.log(dataStatus);
  return dataStatus;
};

export const exceldataFormate = (res) => {
  const excelData = [];
  for (let i = 0; i < res.data.x.length; i++) {
    let points = {};
    // points[res.data.axis['x']]=res.data.x[i];
    if (
      typeof res.data.axis != "undefined" &&
      typeof res.data.axis["x"] != "undefined" &&
      typeof res.data.x != "undefined"
    ) {
      points[res.data.axis["x"]] = isNaN(res.data.x[i])
        ? res.data.x[i]
        : parseFloat(res.data.x[i]);
    }
    if (
      typeof res.data.axis != "undefined" &&
      typeof res.data.axis["x"] != "undefined" &&
      typeof res.data.label != "undefined"
    ) {
      points[res.data.axis["x"]] = isNaN(res.data.label[i])
        ? res.data.label[i]
        : parseFloat(res.data.label[i]);
    }
    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints["y1"] != "undefined" &&
      res.data.datapoints["y1"]
    ) {
      points[res.data.legend["y1"]] = isNaN(res.data.datapoints["y1"][i])
        ? res.data.datapoints["y1"][i]
        : res.data.datapoints["y1"][i] == null
        ? "-"
        : parseFloat(res.data.datapoints["y1"][i]);
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints["y2"] != "undefined" &&
      res.data.datapoints["y2"]
    ) {
      points[res.data.legend["y2"]] = isNaN(res.data.datapoints["y2"][i])
        ? res.data.datapoints["y2"][i]
        : res.data.datapoints["y2"][i] == null
        ? "-"
        : parseFloat(res.data.datapoints["y2"][i]);
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints["y3"] != "undefined" &&
      res.data.datapoints["y3"]
    ) {
      points[res.data.legend["y3"]] = isNaN(res.data.datapoints["y3"][i])
        ? res.data.datapoints["y3"][i]
        : res.data.datapoints["y3"][i] == null
        ? "-"
        : parseFloat(res.data.datapoints["y3"][i]);
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints["y4"] != "undefined" &&
      res.data.datapoints["y4"]
    ) {
      points[res.data.legend["y4"]] = isNaN(res.data.datapoints["y4"][i])
        ? res.data.datapoints["y4"][i]
        : res.data.datapoints["y4"][i] == null
        ? "-"
        : parseFloat(res.data.datapoints["y4"][i]);
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints["y5"] != "undefined"
    ) {
      points[res.data.legend["y5"]] = isNaN(res.data.datapoints["y5"][i])
        ? res.data.datapoints["y5"][i]
        : res.data.datapoints["y5"][i] == null
        ? "-"
        : parseFloat(res.data.datapoints["y5"][i]);
    }
    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints['"5k_to_10k"'] != "undefined"
    ) {
      points[res.data.legend["y1"]] = isNaN(
        res.data.datapoints['"5k_to_10k"'][i]
      )
        ? res.data.datapoints['"5k_to_10k"'][i]
        : parseFloat(res.data.datapoints['"5k_to_10k"'][i]);
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints["10k_to_20k"] != "undefined"
    ) {
      points[res.data.legend["y2"]] = isNaN(
        res.data.datapoints["10k_to_20k"][i]
      )
        ? res.data.datapoints["20k_to_50k"][i]
        : parseFloat(res.data.datapoints["20k_to_50k"][i]);
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints["20k_to_50k"] != "undefined"
    ) {
      points[res.data.legend["y3"]] = isNaN(
        res.data.datapoints["20k_to_50k"][i]
      )
        ? res.data.datapoints["20k_to_50k"][i]
        : parseFloat(res.data.datapoints["20k_to_50k"][i]);
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints["50k_to_100k"] != "undefined"
    ) {
      points[res.data.legend["y4"]] = isNaN(
        res.data.datapoints["50k_to_100k"][i]
      )
        ? res.data.datapoints["50k_to_100k"][i]
        : parseFloat(res.data.datapoints["50k_to_100k"][i]);
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints["<_5k"] != "undefined"
    ) {
      points[res.data.legend["y5"]] = isNaN(res.data.datapoints["<_5k"][i])
        ? res.data.datapoints["<_5k"][i]
        : parseFloat(res.data.datapoints["<_5k"][i]);
    }
    if (
      typeof res.data.legend["y6"] != "undefined" &&
      typeof res.data.datapoints["<_100k"] != "undefined"
    ) {
      points[res.data.legend["y6"]] = isNaN(res.data.datapoints["<_100k"][i])
        ? res.data.datapoints["<_100k"][i]
        : parseFloat(res.data.datapoints["<_100k"][i]);
    }

    if (
      typeof res.data.legend != "undefined" &&
      typeof res.data["y"] != "undefined"
    ) {
      points[res.data.legend] = isNaN(res.data["y"][i])
        ? res.data["y"][i]
        : parseFloat(res.data["y"][i]);
    }
    if (
      typeof res.data.legend["y1"] != "undefined" &&
      typeof res.data.datapoints.y1 != "undefined" &&
      res.data.datapoints.y1 &&
      typeof res.data.datapoints.y1.data != "undefined" &&
      res.data.datapoints.y1.data != null
    ) {
      points[res.data.legend["y1"]] = isNaN(res.data.datapoints.y1.data[i])
        ? res.data.datapoints.y1.data[i]
        : parseFloat(res.data.datapoints.y1.data[i]);
    }
    if (
      typeof res.data.legend["y2"] != "undefined" &&
      typeof res.data.datapoints.y2 != "undefined" &&
      res.data.datapoints.y2 &&
      typeof res.data.datapoints.y2.data != "undefined" &&
      res.data.datapoints.y2.data != null
    ) {
      points[res.data.legend["y2"]] = isNaN(res.data.datapoints.y2.data[i])
        ? res.data.datapoints.y2.data[i]
        : parseFloat(res.data.datapoints.y2.data[i]);
    }
    if (
      typeof res.data.legend["y3"] != "undefined" &&
      typeof res.data.datapoints.y3 != "undefined" &&
      res.data.datapoints.y3 &&
      typeof res.data.datapoints.y3.data != "undefined" &&
      res.data.datapoints.y3.data != null
    ) {
      points[res.data.legend["y3"]] = isNaN(res.data.datapoints.y3.data[i])
        ? res.data.datapoints.y3.data[i]
        : parseFloat(res.data.datapoints.y3.data[i]);
    }
    if (
      typeof res.data.legend["y4"] != "undefined" &&
      typeof res.data.datapoints.y4 != "undefined" &&
      res.data.datapoints.y4 &&
      typeof res.data.datapoints.y4.data != "undefined" &&
      res.data.datapoints.y4.data != null
    ) {
      points[res.data.legend["y4"]] = isNaN(res.data.datapoints.y4.data[i])
        ? res.data.datapoints.y4.data[i]
        : parseFloat(res.data.datapoints.y4.data[i]);
    }
    if (
      typeof res.data.legend["y5"] != "undefined" &&
      typeof res.data.datapoints.y5 != "undefined" &&
      res.data.datapoints.y5 &&
      typeof res.data.datapoints.y5.data != "undefined" &&
      res.data.datapoints.y5.data != null
    ) {
      points[res.data.legend["y5"]] = isNaN(res.data.datapoints.y5.data[i])
        ? res.data.datapoints.y5.data[i]
        : parseFloat(res.data.datapoints.y5.data[i]);
    }
    excelData.push(points);
  }
  return excelData;
};

export const piexceldataFormate = (res, xTitle, yTitle) => {
  const excelData = [];
  for (let i = 0; i < res.data.x.length; i++) {
    let points = {};
    if (typeof res.data.x != "undefined") {
      points[xTitle] = res.data.x[i];
    }
    if (typeof res.data.y != "undefined") {
      points[yTitle] = res.data.y[i];
    }
    excelData.push(points);
  }
  return excelData;
};

export const chartbarThickness = (startDate, endDate) => {
  if (
    endDate.length > 0 &&
    endDate != "ull" &&
    startDate.length > 0 &&
    startDate != "ull"
  ) {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 720) {
      return true;
    }
  }
  return false;
};

export const convertJsonForExcel = (dataArr, headersArr) => {
  var convertedArray = [];
  for (let i = 0; i < dataArr.length; i++) {
    var tempObj = {};
    for (const key in headersArr) {
      if (dataArr[i].hasOwnProperty(key)) {
        if (headersArr[key]["type"] == "string") {
          tempObj[headersArr[key]["name"]] = dataArr[i][key];
        } else if (headersArr[key]["type"] == "int") {
          if (dataArr[i][key] != null) {
            let newData = dataArr[i][key].toString().replaceAll(",", "");
            tempObj[headersArr[key]["name"]] =
              newData == "-" ? "-" : parseFloat(newData);
          }
        }
      }
    }
    convertedArray.push(tempObj);
  }
  return convertedArray;
};

export const collapsableTableData = (data) => {
  let formattedData = [];
  let formattedColumnData = [];
  if (data.length == 0) {
    return { columns: formattedColumnData, data: formattedData };
  }
  formattedColumnData = [{ title: "Region", field: "region" }];

  let columnHeaders = Object.keys(data["Pan India"].data);
  for (let index = 0; index < columnHeaders.length; index++) {
    const element = columnHeaders[index];
    formattedColumnData.push({ title: element, field: element });
  }

  let parentKey = 1;
  for (const [key, value] of Object.entries(data)) {
    let cityObject = value.data;
    cityObject["id"] = parentKey;
    cityObject["region"] = key;
    formattedData.push(cityObject);

    let macroMarket = Object.keys(value);
    for (let i = 0; i < macroMarket.length; i++) {
      if (macroMarket[i] !== "data") {
        parentKey++;
        let macromarketObject = value[macroMarket[i]].data;
        macromarketObject["id"] = parentKey;
        macromarketObject["region"] = macroMarket[i];
        macromarketObject["parentId"] = cityObject["id"];
        formattedData.push(macromarketObject);

        let microMarket = Object.keys(value[macroMarket[i]]);
        for (let j = 0; j < microMarket.length; j++) {
          if (microMarket[j] !== "data") {
            parentKey++;
            let micromarketObject = value[macroMarket[i]][microMarket[j]].data;
            micromarketObject["id"] = parentKey;
            micromarketObject["region"] = microMarket[j];
            micromarketObject["parentId"] = macromarketObject["id"];
            formattedData.push(micromarketObject);
          }
        }
      }
    }
    parentKey++;
  }
  return { columns: formattedColumnData, data: formattedData };
};

export const stackedBarDataFormatToExcel = (tenant, datasets) => {
  let formattedData = [];
  if (tenant.length == 0) {
    let row = [];
    row["Tenant"] = "";
    row["Demand New"] = "";
    row["Demand Renewals"] = "";
    formattedData.push(row);
  } else {
    for (let index = 0; index < tenant.length; index++) {
      // no of rows
      let row = [];
      row["Tenant"] = tenant[index]; // 1st column
      for (let dataIndex = 0; dataIndex < datasets.length; dataIndex++) {
        // 2nd column onwards dynamic columns
        row[datasets[dataIndex].label] = datasets[dataIndex].data[index];
      }
      formattedData.push(row);
    }
  }
  return formattedData;
};

export const keyMapping = {
  city: "markets",
  region: "region",
  macromarket: "macromarkets",
  micromarket: "micromarkets",
  pincode: "pincodes",
  complex: "complexes",
  building: "buildings",
  building_grade: "building-grade",
  // 'propertytype' : 'propertyTypes',
  building_category: "buildingCategory",
  spacetype: "spaceTypes",
  property_condition: "propertyCondition",
  tenant: "tenants",
  sector: "sector",
  developer: "developers",
  landlord: "landlords",
  ownership_type: "ownershipType",
  owner: "owners",
  renewed_lease: "renewed-lease",
  document_type: "documentType",
  active: "lease-status",
  Lease_Id: "creid",
  Sale_Id: "cresaleid",
  seller: "seller",
  purchaser: "purchaser",
  end_status: "endStatus",
  brands_parent: "brandsParent",

  securityDeposit: "securityDeposit",
  startingRent: "startingRent",
  startingRentCarpet: "startingRentCarpet",
  currentRent: "currentRent",
  currentRentCarpet: "currentRentCarpet",
  leaseTerm: "leaseTerm",
  rentFreePeriod: "rentFreePeriod",
  lockinPeriod: "lockinPeriod",
  transactionSize: "transactionSize",
  perSqFt: "perSqFt",
  totalConsideration: "totalConsideration",
  areaPurchased: "areaPurchased",

  start_leaseExpiryDate: "leaseExpiryDateMin",
  end_leaseExpiryDate: "leaseExpiryDateMax",
  start_lockinPeriodEndDate: "lockinPeriodEndDateMin",
  end_lockinPeriodEndDate: "lockinPeriodEndDateMax",
  start_executionDate: "executionDateMin",
  end_executionDate: "executionDateMax",
  start_commencementDate: "commencementDateMin",
  end_commencementDate: "commencementDateMax",
  start_absorptionDate: "absorptionDateMin",
  end_absorptionDate: "absorptionDateMax",
  start_occupancy_date_orig: "occupancy_date_origMin",
  end_occupancy_date_orig: "occupancy_date_origMax",
  start_exitDate: "exitDateMin",
  end_exitDate: "exitDateMax",

  floor_number: "floor_number",

  complexChargeableArea: "complexChargeableArea",
  buildingChargeableArea: "buildingChargeableArea",
};
